import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-coverage-tab-link',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoPipe],
  templateUrl: './coverage-tab-link.component.html',
})
export class CoverageTabLinkComponent {
  readonly labelKey = input.required<string>();

  readonly clicked = output<void>();
}
